import { useAuth } from '../context/AuthContext';

/**
 * Returns true if the current user has the given permission.
 * Usage: const canPublish = usePermission('reports:publish');
 */
export const usePermission = (permission) => {
  const { hasPermission } = useAuth();
  return hasPermission(permission);
};

/**
 * Returns true if the current user has at least one of the given permissions.
 * Usage: const canEdit = useAnyPermission(['deals:create', 'deals:update']);
 */
export const useAnyPermission = (permissions) => {
  const { hasAnyPermission } = useAuth();
  return hasAnyPermission(permissions);
};
